import React from "react";
import "./NoEventsList.scss";
import EventsList from "../EventsList";
import noBreakdowns from "../../assets/imgs/no-breakdowns.png";

const emptyEvent = {
  commentType: "",
  seekTime: "",
  tagedUsers: "",
  position: ""
};
const emptyEvents = new Array(15).fill(emptyEvent);

const NoEventsList = () => (
  <div className="no-events-list">
    <EventsList events={emptyEvents} isEmpty />
    <div className="no-events-list__cover">
      <span>THERE’S NO BEAKDOWN</span>
      <span>AVAILABLE FOR THIS GAME</span>
    </div>
  </div>
);

export default NoEventsList;
